import Vue from 'vue'
import AscSwitch from '@/components/atoms/AscSwitch'
import AscTooltip from '@/components/atoms/AscTooltip'
import variables from '@/styles/_varsJs.scss'

export default Vue.extend({
  components: {
    AscSwitch,
    AscTooltip,
  },

  data() {
    return {
      on: false,
      cellActiveHighlight: false,
      disabled: false,
    }
  },

  computed: {
    getStateHighlightStyles() {
      const hightlight = {
        height: '100%',
        width: '10px',
        position: 'absolute',
        left: 0,
        top: 0,
        'background-color': this.getState
          ? variables.accent500
          : variables.gray200,
      }

      return hightlight
    },
    getSwitchStyles() {
      const switchStyle = {
        'margin-left': this.cellActiveHighlight ? '10px' : 0,
      }

      return switchStyle
    },
    getState() {
      return this.on
    },
    getLabel() {
      return this.params.label || ''
    },
    isDisabled() {
      return this.disabled
    },
    getTooltip() {
      return this.tooltipText
        ? this.tooltipOnDisabledOnly && this.disabled
          ? this.tooltipText
          : ''
        : ''
    },
  },

  created() {
    this.on = this.params.data[this.params.valuefield]
    this.disabled = this.params.data.disabled || false
    this.cellActiveHighlight = this.params.cellActiveHighlight
    this.tooltipOnDisabledOnly = this.params.tooltipOnDisabledOnly || false
    this.tooltipText = this.params.tooltipText
  },

  methods: {
    handleSwitchToggle(value) {
      this.on = value
      this.params.callback({
        ...this.params.data,
        ...{ [this.params.valuefield]: this.on },
      })
    },
  },

  template: `<div style="display: flex; align-items: center;">
    <span v-if="cellActiveHighlight" :style="getStateHighlightStyles"></span>
    <asc-tooltip :tooltip="getTooltip" top :tooltip-length="0">
      <asc-switch :label="getLabel" :style="getSwitchStyles" :value="getState" :disabled="isDisabled" @input="handleSwitchToggle" hide-details></asc-switch>
    </asc-tooltip>
  </div>`,
})
